import { McpApplicationListItem } from 'core/interfaces/Application'
import { SelectedMcpApplication } from 'lauria/types/mcpApplication'

export const mapMcpApplicationToSelectedAgent = (
  application: McpApplicationListItem
): SelectedMcpApplication => ({
  id: application.id,
  label: application.nomTechnique,
})
